<template>
  <v-dialog v-model="dialog"
            width="900"
            @click:outside="cancelDialog()" >
    <v-card>
    <v-stepper v-model="step" vertical>

      <v-stepper-step step="1" editable>
        <h2>Select type of analysis: {{analysisType}}</h2>
      </v-stepper-step>
      <v-stepper-content step="1">
        <v-radio-group v-model="analysisType" @change="step = 2">
          <v-radio v-for="type in ['Influence','Micro-Influence', 'Exposition', 'Expression']"
            :key="type"
            :label="type"
            :value="type"
          ></v-radio>
        </v-radio-group>
      </v-stepper-content>

      <v-stepper-step step="2" editable>
        <h2>Select cross-section of communities</h2>
      </v-stepper-step>
      <v-stepper-content step="2">
        <VennSelect
          :options="selectionsListDefinition"
          :sets="analysis_template ? analysis_template.query_ve.value.communities:[]"
          v-model="selections"
          @confirm="confirmCommunitySelection($event)"
        >
        </VennSelect>
      </v-stepper-content>

      <template v-if="analysisType === 'Exposition'">
        <v-stepper-step step="3" editable>
          <h2>Select field of expression</h2>
        </v-stepper-step>
        <v-stepper-content step="3">
            <SelectExisting max="1" v-model="exposedToselected" :communities="communities"
                            @input="submitDialog()">
            </SelectExisting>
        </v-stepper-content>
      </template>

      <template v-if="analysisType === 'Expression'">
        <v-stepper-step step="3" editable>
          <h2>Select field of expression</h2>
        </v-stepper-step>
        <v-stepper-content step="3">
              <div>
                Expression analyses can be scoped to specific field of expression. If not needed leave empty.
              </div>
              <v-text-field placeholder="phrase1;phrase2" v-model="field_of_expression"
                :hint="'format: ph1;ph2 for OR | ph1,ph2 for AND. Cannot be mixed.'"
              >
              </v-text-field>
              <p/>
            <v-btn class="custom-btn"
                   color="secondary" @click="submitDialog()">
              Confirm ➞
            </v-btn>
        </v-stepper-content>
      </template>

    </v-stepper>

    </v-card>
  </v-dialog>
</template>

<script>
  import VennSelect from "../../Community/VennSelect"
  import SelectExisting from "../../Community/SelectExisting"
  import { mapState } from 'vuex'
  import { keyToQuery } from '../../../_utils/communityNames'


  export default {
      components: { VennSelect, SelectExisting  },
      props: ['dialog_visible', 'analysis_template'],
      data () {
          return {
              dialog: false,
              step: 1,
              analysisType: "",
              selections: [],
              exposedToselected: [],
              field_of_expression: "",
            }
      },
      computed: {
        is_form_ready: function () {
          return this.step < 2; // TODO make this really validating the form
        },
        analysis: function () { // TODO generate_analysis_partial
          if (!this.analysis_template) {
            return {}
          }
          let selected = _.map(this.selections, e => e.key)
          let r = {
              type: this.analysisType,
              query_ve: {
                kind: this.analysis_template.query_ve.kind,
                value: {
                  communities: this.analysis_template.query_ve.value.communities,
                  selection: this.analysis_template.query_ve.value.selection.map( (s,i) => {
                        return {
                          key: s.key,
                          label: s.label,
                          sets: s.sets,
                          checked: _.includes(selected, s.key)
                        }
                  })

                }
              }
          }
          if (this.analysisType === "Exposition") {
            r.field_of_expression_query = keyToQuery(this.exposedToselected[0].key)
          }
          if (this.analysisType === "Expression") {
            r.field_of_expression = this.field_of_expression;
          }
          return r
        },
        selectionsListDefinition: function () {
          if ( this.analysis_template == null ) {
            return [];
          }
          else {
              return this.analysis_template.query_ve.value.selection.map(s => {
                 return {
                   sets: s.sets,
                   key: String(s.key),
                   label: String(s.label),
                   checked: !!s.checked,
                 }
              })
          }
        },
        ...mapState({communities: "communities"})
      },
      methods: {
        cancelDialog: function() {
            this.$emit('cancel')
        },
        submitDialog: function() {
          this.$emit('create', this.analysis)
        },
        confirmCommunitySelection: function(event) {
            if (this.analysisType == "Exposition"
                || this.analysisType == "Expression") {
                this.step = 3
            }
            else {
               this.submitDialog()
            }
        }
      },
      watch: {
        dialog_visible (val, oldVal){
          this.step = 1;
          this.analysisType = ""
          this.dialog = val;
        }
      }
  }
</script>
